import type { Submission } from '../../lib/types'
import { C } from '../../lib/colors'

const TIER_COLORS = [C.tier[0], C.tier[1], C.tier[2], C.tier[3]]

interface Props {
  data: Submission[]
  onContact: (id: number) => void
}

export function Triage({ data, onContact }: Props) {
  const sorted = [...data].sort((a, b) => {
    if (b.tier !== a.tier) return b.tier - a.tier
    return b.total_score - a.total_score
  })

  return (
    <section className="sec" id="triage">
      <div className="sec-hd">
        <div className="sec-label">10 · Clinical Triage</div>
        <h2 className="sec-title">Submissions sorted by clinical priority</h2>
        <p className="sec-sub">Sorted by tier (4→1), then by total score descending. Click "Contact" to decrypt and view a patient's name and email.</p>
      </div>
      <div className="card">
        <div className="triage-wrap">
          <table className="triage-tbl">
            <thead>
              <tr>
                <th>#</th><th>Tier</th><th>Score</th><th>Signals</th>
                <th>Red flag</th><th>Age</th><th>Location</th>
                <th>Cycle</th><th>Contra</th><th>Date</th><th />
              </tr>
            </thead>
            <tbody>
              {sorted.map((row, idx) => {
                const signals = ['signal_prolactin', 'signal_androgens', 'signal_insulin', 'signal_thyroid']
                  .filter(f => row[f as keyof Submission] === 'signalled')
                  .map(f => f.replace('signal_', '').slice(0, 3).toUpperCase())

                return (
                  <tr key={row.id}>
                    <td style={{ fontFamily: 'var(--f-mono)', fontSize: 10, color: 'var(--t3)' }}>{idx + 1}</td>
                    <td>
                      <span className="tier-badge" style={{ background: TIER_COLORS[row.tier - 1] + '22', color: TIER_COLORS[row.tier - 1] }}>
                        T{row.tier}
                      </span>
                    </td>
                    <td style={{ fontFamily: 'var(--f-mono)', fontSize: 11, color: 'var(--t1)' }}>{row.total_score}</td>
                    <td>
                      <div className="sig-pills">
                        {signals.map(s => <span key={s} className="sig-pill">{s}</span>)}
                      </div>
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      {row.has_red_flag ? <span className="rf-dot" title="Red flag" /> : null}
                    </td>
                    <td style={{ fontSize: 10, color: 'var(--t2)' }}>{row.age_bracket ?? '—'}</td>
                    <td style={{ fontSize: 10, color: 'var(--t2)', whiteSpace: 'nowrap' }}>{row.location ?? '—'}</td>
                    <td style={{ fontSize: 10, color: 'var(--t2)' }}>{row.cycle_classification ?? '—'}</td>
                    <td style={{ fontSize: 10, color: 'var(--t2)' }}>{row.contraception_status ?? '—'}</td>
                    <td style={{ fontFamily: 'var(--f-mono)', fontSize: 10, color: 'var(--t3)', whiteSpace: 'nowrap' }}>
                      {new Date(row.created_at).toLocaleDateString('en-GB')}
                    </td>
                    <td>
                      <button className="btn-contact" onClick={() => onContact(row.id)}>Contact</button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  )
}
